const DEBUG = true;

export const CONTENT_TYPE_JSON = "application/json";
export const CONTENT_TYPE_FORM = "application/x-www-form-urlencoded";
// export const CONTENT_TYPE_FORM = "application/json";
import axios from 'axios'

let development=process.env.NODE_ENV == 'development' ? true : false;
var BaseUrl = ''

// BaseUrl = development?'/JojoSila/client/':'../../client/';
 
// BaseUrl = 'https://php.uummii.online/api/client/';

// BaseUrl = 'https://php.uummii.online/api';
BaseUrl = 'https://test.uummii.online/api';
// BaseUrl = '';

const netFetch = function (url, method = 'GET', params, json, header, type){

    if(!url.includes('http') && !url.includes('StageKids')){
        url = BaseUrl+url;
    }
    
    let headers = {};
    if (header) {
        headers = Object.assign({}, headers, header)
    }

    let requestParams;

    //headers.Authorization = this.optionParams.authorizationCode;

    if (method !== 'GET') {
        if (json) {
            requestParams = formParamsJson(method, params, headers)
        } else {
            requestParams = formParams(method, params, headers)
        }
    } else {
        requestParams = formParams(method, params, headers)
    }

    return fetch(url, requestParams, type);
}


var formParamsJson = function(method, params, headers) {
    const body = JSON.stringify(params);
    const req = {
        method: method,
        headers: {
            'Content-Type': CONTENT_TYPE_JSON,
            ...(headers || {})
        },
        body
    };
    return req
}


var formParams = function (method, params, headers) {
    const str = [];
    for (let p in params) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(params[p]));
    }
    let body = params;
    const req = {
        method: method,
        headers: {
            'Content-Type': CONTENT_TYPE_FORM,
            ...(headers || {})
        }
        ,
        body
    };
    return req
}

var fetch = function(path, requestParams, type = 'json') {
    const stream = axios;
    return new Promise((resolve, reject) => {
        stream({
            method:requestParams.method,
            url:path,
            headers:requestParams.headers,
            data:requestParams.method === 'GET' ? "" : requestParams.body,
            transformRequest: [function (data) {
                let ret = ''
                for (let it in data) {
                    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                }
                return ret
                }],
        }).then((res)=>{
            if(res.status == 200){
                resolve(res.data)
            }else{
                reject()
            }
        })
    })
}


export default netFetch



// WEBPACK FOOTER //
// ./src/config/api.js